var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{staticClass:"justify-space-between mb-4"},[_c('v-col',[_c('p',{staticStyle:{"color":"#4477ad","font-size":"26px"}},[_vm._v(" "+_vm._s(_vm.data.namePage)+" "),_c('span',{staticStyle:{"margin-left":"5px"}},[_vm._v("("+_vm._s(_vm.getList.length)+")")])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }